/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rules_Kind_Core_TitleInputs */



/**
* | output |
* | --- |
* | "Core Rules" |
*
* @param {Rules_Kind_Core_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const rules_kind_core_title = /** @type {((inputs?: Rules_Kind_Core_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rules_Kind_Core_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Grundregeln")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Règles de base")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("核心规则")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("核心規則")
	if (locale === "ko") return /** @type {LocalizedString} */ ("핵심 규칙")
	return /** @type {LocalizedString} */ ("Core Rules")
});